import React from 'react';

import { 
  Grid,
}                         from '@material-ui/core';
import { makeStyles }     from '@material-ui/core/styles';

import { Storage }        from '../components/dashboard';

const useStyles = makeStyles((theme) => ({
  root: {
  },
}));

export default function Dashboard(props) {
  const classes = useStyles();

  // note: spacing > 1 can cause overflow and horizontal scrollbars, xs={12} avoids this
  return (
    <Grid container item className={classes.root} spacing={0} xs={12}>
      <Grid item>
        <Storage/>
      </Grid>
    </Grid>
  );
}